import { confirmedGroupList } from './confirmed-group-list';
import {
  CREATE_CONFIRMEDGROUP_ERROR,
  CREATE_CONFIRMEDGROUP_SUCCESS,
  DELETE_CONFIRMEDGROUP_ERROR,
  DELETE_CONFIRMEDGROUP_SUCCESS,
  FILTER_CONFIRMEDGROUP,
  LOAD_CONFIRMEDGROUP_SUCCESS,
  UNDELETE_CONFIRMEDGROUP_ERROR,
  UNLOAD_CONFIRMEDGROUP_SUCCESS,
  UPDATE_CONFIRMEDGROUP_ERROR,
  UPDATE_CONFIRMEDGROUP_SUCCESS
} from './action-types';


// export function createTask(title) {
//   return dispatch => {
//     taskList.push({completed: false, title})
//       .catch(error => dispatch(createTaskError(error)));
//   };
// }

// export function createTaskError(error) {
//   return {
//     type: CREATE_TASK_ERROR,
//     payload: error
//   };
// }

export function createConfirmedGroupSuccess(group) {
  return {
    type: CREATE_CONFIRMEDGROUP_SUCCESS,
    payload: group
  };
}

// export function deleteTask(task) {
//   return dispatch => {
//     taskList.remove(task.key)
//       .catch(error => dispatch(deleteTaskError(error)));
//   };
// }

// export function deleteTaskError(error) {
//   return {
//     type: DELETE_TASK_ERROR,
//     payload: error
//   };
// }

export function deleteConfirmedGroupSuccess(group) {
  return {
    type: DELETE_CONFIRMEDGROUP_SUCCESS,
    payload: group
  };
}

// export function undeleteTask() {
//   return (dispatch, getState) => {
//     const task = getDeletedTask(getState());
//     if (task) {
//       taskList.set(task.key, {completed: task.completed, title: task.title})
//         .catch(error => dispatch(undeleteTaskError(error)));
//     }
//   };
// }
//
// export function undeleteTaskError(error) {
//   return {
//     type: UNDELETE_TASK_ERROR,
//     payload: error
//   };
// }

export function updateConfirmedGroupError(error) {
  return {
    type: UPDATE_CONFIRMEDGROUP_ERROR,
    payload: error
  };
}

export function updateConfirmedGroup(group, changes) {
  return dispatch => {
    confirmedGroupList.update(group.key, changes)
      .catch(error => dispatch(updateConfirmedGroupError(error)));
  };
}

export function updateConfirmedGroupSuccess(group) {
  return {
    type: UPDATE_CONFIRMEDGROUP_SUCCESS,
    payload: group
  };
}

export function loadConfirmedGroupSuccess(group) {
  return {
    type: LOAD_CONFIRMEDGROUP_SUCCESS,
    payload: group
  };
}

// export function filterTasks(filterType) {
//   return {
//     type: FILTER_TASKS,
//     payload: {filterType}
//   };
// }

export function loadConfirmedGroup() {
  return (dispatch, getState) => {
    const { auth } = getState();
    confirmedGroupList.path = `confirmed-groups`;
    const lookUp = {
      queryChild: auth.id,
      queryString: true,
      lookUpType: "equalTo"
    }
    confirmedGroupList.subscribe(dispatch, lookUp);
  };
}

export function unloadConfirmedGroup() {
  confirmedGroupList.unsubscribe();
  return {
    type: UNLOAD_CONFIRMEDGROUP_SUCCESS
  };
}

export function createPreference(room, rank) {
  return {
    type: "CREATE_PREFERENCE",
    payload: { room, rank }
  }
}

export function preferenceAlreadyAdded() {
  return {
    type: "PREFERENCE_ALREADY_ADDED"
  }
}

export function preferenceRankChange() {
  return {
    type: "PREFERENCE_RANK_CHANGE"
  }
}

export function preferenceGroupSizeMismatch() {
  return {
    type: "PREFERENCE_GROUP_CAP_MISMATCH"
  }
}

export function currentUserSubmitPreferences() {
  return {
    type: "CURRENT_USER_SUBMIT_PREFS"
  }
}


// WEBPACK FOOTER //
// ./src/core/confirmed-group/actions.js